module.exports = __webpack_public_path__ + "static/media/ring.66353e06.svg";